import {useEffect, useState} from "react";
import axios from "axios";
import {activity_test_problem_response, restUrl} from "../../../../apiUrl";
import {AboutTest} from "../component/AboutTest";
import "../../../../root-css.css"
import {useLocation, useNavigate} from "react-router-dom";

export default function TestTrans() {

    const {state} = useLocation()

    function transformProblems(data) {
        return data.map(item => {
            const translation = item.selection?.trim() || "";
            return {
                application_id : state.appId,
                problem_id : item.id || "",
                originalText: item.problem.trim(),
                translateText: translation,
                response: translation
            };
        });
    }
    
    const [processData, setProcessData] = useState([]);
    
    useEffect(() => {
        axios.get(`${restUrl}/activity_test_problem_view_trans?test_id=eq.${state.testId}`)
            .then(res => {
            const result = transformProblems(res.data);
            setProcessData(result);
        });
    }, []);
    
    // ✅ textarea 변경 핸들러
    const handleTextareaChange = (index, key, event) => {
        const newValue = event.target.value;
        setProcessData(prev => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                [key]: newValue
            };
            return updated;
        });
    };

    const navigate = useNavigate();
    return (
        <>
            <AboutTest  testId={state.testId}/>
            <ul className={`flex gap-3`}>
                {["원문", "번역된 내용", "에디터"].map((item, index) => (
                    <li key={index} className={`w-full px-2 py-3 bg-slate-800 text-white`}>{item}</li>
                ))}
            </ul>
            <ul className={`w-full`}>
                {processData.map((item, index) => (
                    <li
                        key={index}
                        className={`flex w-full gap-3 [&_*]:p-2 mb-1 [&_*]:w-full [&_*]:h-[10rem] [&_*]:border-2`}
                    >
                        {/* 원문 - 읽기 전용 */}
                        <textarea
                            value={item.originalText}
                            readOnly
                            className={`border-2 border-black`}
                        />
                        {/* 번역된 내용 - 읽기 전용 */}
                        <textarea
                            value={item.translateText}
                            readOnly
                            className={`border-2 border-black`}
                        />
                        {/* 에디터 - 수정 가능 */}
                        <textarea
                            value={item.response}
                            className={`border-2 border-black`}
                            onChange={(e) => handleTextareaChange(index, 'response', e)}
                        />
                    </li>
                ))}
            </ul>
            <button
                onClick={async() => {
                    const ok = window.confirm('제출하시겠습니까?')
                    if (!ok) return
                    const cleanedArray = processData.map(({translateText, originalText, ...rest}) => rest);
                    await axios.post(`${restUrl}/${activity_test_problem_response}`,cleanedArray)
                    navigate(-1)
                }}
            >제출하기
            </button>
        </>
    );
}
